import { FuneralHomeInfoEmbed } from '@shared/api/funeralHomeInfoRequest/funeralHomeInfoRequest.interface';
import { FeventDate, Gender } from '@shared/types';

//* 고인정보입력을 위한 parameters
export enum DeceasedInfoFormInputsEnum {
  RegisterNumber = 'registerNumber',
  Name = 'name',
  Age = 'age',
  Sex = 'sex',
  BugoTerm = 'bugoTerm',
  EnteranceDate = 'enteranceDate',
  DeathDate = 'deathDate',
  CoffinInDate = 'coffinInDate',
  CoffinOutDate = 'coffinOutDate',
  Cemetery = 'cemetery',
  FuneralHomeInfo = 'funeralHomeInfo',
  FuneralHomeInfoName = 'funeralHomeInfoName',
  FuneralHomeInfoEmbed = 'funeralHomeInfoEmbed',
  //* 호실은 직접 입력(roomInfoEmbed.name)만. 호실 참조(roomInfo)는 실데이터 0건이라 폐기
  RoomInfoEmbedName = 'roomInfoEmbedName',
  MournerText = 'mournerText',
  DpImage = 'dpImage',
  BugoBrandAgencyIndex = 'bugoBrandAgencyIndex',
  KakaoShareTemplateId = 'kakaoShareTemplateId',
  UseAcqMsg = 'useAcqMsg',
}

export interface DeceasedInfoIFormInputs {
  [DeceasedInfoFormInputsEnum.Name]: string;
  [DeceasedInfoFormInputsEnum.Age]: number;
  [DeceasedInfoFormInputsEnum.Sex]: Gender;
  [DeceasedInfoFormInputsEnum.DeathDate]: FeventDate;
  [DeceasedInfoFormInputsEnum.EnteranceDate]: FeventDate;
  [DeceasedInfoFormInputsEnum.CoffinInDate]: FeventDate;
  [DeceasedInfoFormInputsEnum.CoffinOutDate]: FeventDate;
  [DeceasedInfoFormInputsEnum.Cemetery]: string;
  [DeceasedInfoFormInputsEnum.BugoTerm]: string;
  [DeceasedInfoFormInputsEnum.FuneralHomeInfo]: string;
  [DeceasedInfoFormInputsEnum.FuneralHomeInfoName]: string;
  [DeceasedInfoFormInputsEnum.FuneralHomeInfoEmbed]?: FuneralHomeInfoEmbed;
  [DeceasedInfoFormInputsEnum.RoomInfoEmbedName]?: string;
  [DeceasedInfoFormInputsEnum.MournerText]: string;
  [DeceasedInfoFormInputsEnum.RegisterNumber]?: string;
  [DeceasedInfoFormInputsEnum.DpImage]?: string;
  [DeceasedInfoFormInputsEnum.BugoBrandAgencyIndex]?: number;
  [DeceasedInfoFormInputsEnum.KakaoShareTemplateId]?: string;
  [DeceasedInfoFormInputsEnum.UseAcqMsg]?: boolean;
}
